import React from "react";
import { Typography, Grid } from "@material-ui/core";
import EducationText from "../Texts/EducationText";

export default () => {
  return (
    <div className="education section" id="education">
      <div className="text-container">
        <Grid container>
          <Grid item sm={1} />
          <Grid item xs={12} sm={10}>
            <EducationText />
          </Grid>
          <Grid item sm={1} />
        </Grid>
      </div>
      <div className="transparent" id="education-background">
        <Typography className="rubik-font f-large">Education</Typography>
      </div>
    </div>
  );
};
